/**
 * @file breakpoints.ts
 *
 * @fileoverview Exports screen sizes for different devices.
 */
export type ScreenSizeType = "mobile" | "tablet" | "desktop";
export const ScreenSizeMap: Record<ScreenSizeType, number> = {
  mobile: 899,
  tablet: 1199,
  desktop: 1499,
};
